//import React from 'react';

/**
 * ChatMessage - Displays a single chat message
 * Handles both user and assistant messages with different styling
 */
function ChatMessage({ message }) {
  const { role, content, timestamp, isError, products } = message;
  const isUser = role === 'user';

  return (
    <div className={`chat-message ${isUser ? 'user-message' : 'assistant-message'}`}>
      {!isUser && (
        <div className="message-avatar">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2 2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
            <rect x="3" y="8" width="18" height="12" rx="2" />
          </svg>
        </div>
      )}

      <div className="message-content">
        <div className={`message-bubble ${isError ? 'error-bubble' : ''}`}>
          {content}
        </div>

        {products && products.length > 0 && (
          <div className="message-products">
            {products.map((product, index) => (
              <div key={index} className="chat-product-card">
                {product.photo && (
                  <img
                    src={product.photo}
                    alt={product.name}
                    className="chat-product-image"
                  />
                )}
                <div className="chat-product-info">
                  <div className="chat-product-name">{product.name}</div>
                  <div className="chat-product-price">${product.price.toFixed(2)}</div>
                  {product.description && (
                    <div className="chat-product-description">
                      {product.description}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {timestamp && (
          <div className="message-time">
            {new Date(timestamp).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default ChatMessage;
